import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';

export const CookiePolicy = () => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-50 to-white py-24">
      <div className="max-w-4xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="bg-white/60 backdrop-blur-sm rounded-3xl p-12 border border-white/20 shadow-2xl"
        >
          <div className="text-center mb-12">
            <h1 className="text-4xl lg:text-5xl font-black mb-6 bg-gradient-to-r from-orange-600 to-pink-600 bg-clip-text text-transparent">
              {t('legal.cookies_title')}
            </h1>
            <p className="text-slate-600 text-lg">
              {t('legal.last_updated')} {new Date().toLocaleDateString()}
            </p>
          </div>

          <div className="prose prose-slate max-w-none space-y-8">
            <section>
              <h2 className="text-2xl font-bold text-slate-800 mb-4">{t('legal.cookies_intro_title')}</h2>
              <p className="text-slate-600 leading-relaxed">
                {t('legal.cookies_intro_text')}
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-slate-800 mb-4">{t('legal.cookies_types_title')}</h2>
              
              <div className="space-y-4">
                <div>
                  <h3 className="text-lg font-semibold text-slate-700 mb-2">{t('legal.cookies_essential_title')}</h3>
                  <p className="text-slate-600 leading-relaxed">{t('legal.cookies_essential_text')}</p>
                </div>
                
                <div>
                  <h3 className="text-lg font-semibold text-slate-700 mb-2">{t('legal.cookies_analytical_title')}</h3>
                  <p className="text-slate-600 leading-relaxed">{t('legal.cookies_analytical_text')}</p>
                </div>
                
                <div>
                  <h3 className="text-lg font-semibold text-slate-700 mb-2">{t('legal.cookies_preference_title')}</h3>
                  <p className="text-slate-600 leading-relaxed">{t('legal.cookies_preference_text')}</p>
                </div>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-slate-800 mb-4">{t('legal.cookies_third_title')}</h2>
              <p className="text-slate-600 leading-relaxed">
                {t('legal.cookies_third_text')}
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-slate-800 mb-4">{t('legal.cookies_children_title')}</h2>
              <p className="text-slate-600 leading-relaxed">
                {t('legal.cookies_children_text')}
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-slate-800 mb-4">{t('legal.cookies_control_title')}</h2>
              <div className="space-y-3">
                <p className="text-slate-600 leading-relaxed">{t('legal.cookies_control_browser')}</p>
                <p className="text-slate-600 leading-relaxed font-medium text-slate-700">
                  {t('legal.cookies_control_impact')}
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-slate-800 mb-4">{t('legal.cookies_retention_title')}</h2>
              <p className="text-slate-600 leading-relaxed">
                {t('legal.cookies_retention_text')}
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-slate-800 mb-4">{t('legal.cookies_updates_title')}</h2>
              <p className="text-slate-600 leading-relaxed">
                {t('legal.cookies_updates_text')}
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-slate-800 mb-4">{t('legal.contact_title')}</h2>
              <p className="text-slate-600 leading-relaxed">
                {t('legal.cookies_contact_text')}
              </p>
            </section>

            <section className="border-t border-slate-200 pt-6">
              <p className="text-slate-500 text-sm italic">
                {t('legal.effective_date')}
              </p>
            </section>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default CookiePolicy;